const BRANCH_LIST_URL = "/v1/erp/branch/list";
const ERP_WAREHOUSE_LIST_URL = "/v1/erp/warehouse/list";
const LIST_URL = "/v1/company/list";
const COMPANY_BRANCH_LIST_URL = "/v1/company/branch/list";
const COMPANY_BRANCH_ADD_URL = "/v1/company/branch/add";
const COMPANY_BRANCH_UPDATE_URL = "/v1/company/branch/update";
const COMPANY_BRANCH_DELETE_URL = "/v1/company/branch/delete";
const COMPANY_WAREHOUSE_LIST_URL = "/v1/company/warehouse/list";
const COMPANY_WAREHOUSE_ADD_URL = "/v1/company/warehouse/add";
const COMPANY_WAREHOUSE_UPDATE_URL = "/v1/company/warehouse/update";
const COMPANY_WAREHOUSE_DELETE_URL = "/v1/company/warehouse/delete";

const COMPANY_API_URL_LIST = {
    BRANCH_LIST_URL,
    LIST_URL,
    COMPANY_BRANCH_LIST_URL,
    COMPANY_BRANCH_ADD_URL,
    COMPANY_BRANCH_UPDATE_URL,
    COMPANY_BRANCH_DELETE_URL,
    COMPANY_WAREHOUSE_LIST_URL,
    COMPANY_WAREHOUSE_ADD_URL,
    COMPANY_WAREHOUSE_UPDATE_URL,
    COMPANY_WAREHOUSE_DELETE_URL,
    ERP_WAREHOUSE_LIST_URL,
}

export { COMPANY_API_URL_LIST };